export default __webpack_public_path__ + "static/media/CDDC292C-6393-4ED9-BB89-BF97F6B9C6B4.ca6756dc.jpeg";